export default "__VITE_ASSET__52069ae2__"